export default __webpack_public_path__ + "static/media/calender-two.a9eb5e36.svg";